import React from "react";
import Accordion from "../../Accordion";
import * as S from "./styles";
export var FooterAccordionItem = function FooterAccordionItem(_ref) {
  var e = _ref.heading,
      t = _ref.listOfLinkObjects,
      o = _ref.showBorderBottom,
      r = _ref.onClickLink;
  return React.createElement(Accordion.Item, null, React.createElement(S.AccordionHeading, null, e), React.createElement(Accordion.Child, {
    showBorderBottom: o
  }, function (e) {
    return React.createElement(S.CategoryList, null, Object.entries(t).map(function (t, o) {
      return React.createElement(S.CategoryListItem, {
        key: "dt-footer-link-".concat(o)
      }, React.createElement(S.FooterLink, {
        href: t[1],
        tabIndex: e ? "0" : "-1",
        onClick: function onClick() {
          return r && r(t[0]);
        }
      }, t[0]));
    }));
  }));
};
export default FooterAccordionItem;